'use strict';

var messageModule = angular.module('t2g.message', [
  'gettext',
  'ui.router',
  require('t2g.common.services.notificationService').name,
  require('t2g.common.services.modalService').name,
]);

module.exports = messageModule;

messageModule.controller('MailCtrl', require('./types/MailCtrl'));
messageModule.controller('MessageBoxCtrl', require('./MessageBoxCtrl'));
messageModule.controller('MessageCtrl', require('./types/MessageCtrl'));
messageModule.controller('SMSCtrl', require('./types/SMSCtrl'));

messageModule.config(function($stateProvider) {
  $stateProvider
    .state('private.main.messages', {
      url: '/message/:box',
      title: 'Messages',
      templateUrl: '/app/modules/message/MessageBoxView.html?v=4.5.6',
      controller: 'MessageBoxCtrl as MessageBoxCtrl',
      resolve: {
        messagesResolve: function($q, $stateParams, Message) {
          var deffered = $q.defer();

          Message.get($stateParams.box).then(
            function(messages) {
              deffered.resolve(messages);
            },
            function(error) {
              deffered.reject(error);
            },
          );

          return deffered.promise;
        },
      },
    })
    .state('private.main.message', {
      url: '/message/',
      title: 'Messages',
      controller: 'MessageCtrl as MessageCtrl',
      templateUrl: '/app/modules/message/types/MessageView.html?v=4.5.6',
    })
    .state('private.main.message.mail', {
      url: 'mail/:messageId',
      title: 'Messages',
      controller: 'MailCtrl as MailCtrl',
      templateUrl: '/app/modules/message/types/MailView.html?v=4.5.6',
      resolve: {
        messageResolve: function($q, $stateParams, Message) {
          var deffered = $q.defer();

          Message.getOne($stateParams.messageId).then(
            function(messages) {
              deffered.resolve(messages);
            },
            function(error) {
              deffered.reject(error);
            },
          );

          return deffered.promise;
        },
      },
    })
    .state('private.main.message.sms', {
      url: 'sms/:messageId',
      title: 'Messages',
      controller: 'SMSCtrl as SMSCtrl',
      templateUrl: '/app/modules/message/types/SMSView.html?v=4.5.6',
      resolve: {
        messageResolve: function($q, $stateParams, Message) {
          var deffered = $q.defer();

          Message.getOne($stateParams.messageId).then(
            function(messages) {
              deffered.resolve(messages);
            },
            function(error) {
              deffered.reject(error);
            },
          );

          return deffered.promise;
        },
      },
    });
});



// WEBPACK FOOTER //
// ./src/app/modules/message/messageModule.js